<template>
  <Card class="tasks-widget">
    <template #default>
      <div class="tasks-widget__title row between baseline">
        <div class="card__title">{{ $tc('task', 2) }}</div>
        <a v-if="showCreate" href="#" @click.prevent="$bus.$emit('task', { reference })">{{ $t('create') }}</a>
      </div>

      <div v-if="items.length" class="tasks-widget__items">
        <component :is="item.typename" v-for="(item, index) in items" :key="index" :value="item" />
      </div>

      <EmptyState v-else :title="$t('noTasks')" :icon="['fal', 'tasks']" class="grow-1 mb-2" />
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import CreateTask from '@/components/Task/CreateButton'
import EmptyState from '@/components/EmptyState'
import Types from './Types'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    reference: Object,
    showCreate: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    items() {
      return this.value.filter(v => v.status !== 'done')
    },
  },
  components: {
    Card,
    EmptyState,
    CreateTask,
    ...Types,
  },
}
</script>

<style lang="scss">
.tasks-widget {
  overflow: hidden;

  .card__content {
    display: flex;
    flex-direction: column;
    padding: 0;
    flex-grow: 1;
    overflow-y: auto;

    @include scrollShadow();
  }

  .card__title {
    margin-bottom: 0;
  }

  &__title {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: var(--card-spacing);
    background: linear-gradient(to bottom, white 55%, rgba(255, 255, 255, 0));
  }

  &__items {
    padding: 0 var(--card-spacing) var(--card-spacing) var(--card-spacing);
    margin-top: calc(var(--card-spacing) * -0.5);
  }
}
</style>
